import { createSlice } from "@reduxjs/toolkit";
import { TelemetryItem } from "@/facilities/model/user";

export interface PublicState {
  monitPanel: TelemetryItem[];
}
const initialState: PublicState = {
  monitPanel: [],
};

export const publicSlice = createSlice({
  name: "Public",
  initialState,
  reducers: {
    setMonitPanel: (state, { payload }) => {
      state.monitPanel = payload;
    },
  },
});

export const { setMonitPanel } = publicSlice.actions;
export default publicSlice.reducer;
